import { concatPath } from '../../../utils/links/concatPath';
import { faceScanStackKey, privateKey } from '../../../constants/routeKeys';
import { router } from 'expo-router';

export const useGoToFaceScan = () => {
  const goToFaceScan = () => {
    const path = concatPath([privateKey, faceScanStackKey], -1) as string;
    console.log('[useGoToFaceScan.web] goToFaceScan called, navigating to:', path);
    router.navigate(path);
    console.log('[useGoToFaceScan.web] Navigation triggered');
  };

  return { goToFaceScan };
};
